import { map, type OperatorFunction } from 'rxjs';

import { type ApiResponse } from '../types/api-response';

import { assertNonNull } from './assert-non-null';

export function mapDataNonNull<TDto, TDomain>(
  fn: (dto: TDto) => TDomain,
): OperatorFunction<ApiResponse<TDto>, ApiResponse<TDomain>> {
  return map((res) => {
    assertNonNull(res.data);

    return {
      data: fn(res.data),
      pagination: res.pagination,
    };
  });
}
